export enum EDashboardSortFields {
  PROJECT = "project",
  CONTRACT = "contract",
  CLIENT = "client",
  LOCATION = "location",
  CREATED_DATE = "createdAt",
}
